import React from 'react';
import { getRooms } from '../../SearchEntryWidget/defaultData';
import { RadioSelect } from '../../RadioSelect';
export const RoomSelect = ({ onChange = () => { }, rooms = getRooms(), value = null, }) => <RadioSelect onChange={onChange} values={rooms} value={value}/>;
export default RoomSelect;
